/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Component, OnInit, Input } from '@angular/core';
import { HomeComponent } from './home.component';
import 'rxjs/add/operator/first';

@Component({
    templateUrl: 'default.component.html',
    styleUrls: ['home.component.css'],
    selector: '[default-row]',
})

export class DefaultRowComponent extends HomeComponent implements OnInit {
    @Input() registro: any;

    ngOnInit() {

    }
}